<div class="info-page">
  <header class="info-hero">
    <p class="info-kicker">The fine print</p>
    <h1 class="info-heading">Terms &amp; Conditions</h1>
    <p class="info-sub">By using LootLucky you agree to these terms.</p>
  </header>

  <nav class="info-toc" aria-label="Terms sections">
    <a href="#terms-use" (click)="scrollTo($event, 'terms-use')">Use</a>
    <a href="#terms-accounts" (click)="scrollTo($event, 'terms-accounts')">Accounts</a>
    <a href="#terms-payments" (click)="scrollTo($event, 'terms-payments')">Payments</a>
    <a href="#terms-shipping" (click)="scrollTo($event, 'terms-shipping')">Shipping</a>
    <a href="#terms-returns" (click)="scrollTo($event, 'terms-returns')">Returns</a>
    <a href="#terms-products" (click)="scrollTo($event, 'terms-products')">Products</a>
    <a href="#terms-ip" (click)="scrollTo($event, 'terms-ip')">IP</a>
    <a href="#terms-liability" (click)="scrollTo($event, 'terms-liability')">Liability</a>
    <a href="#terms-law" (click)="scrollTo($event, 'terms-law')">Law</a>
    <a href="#terms-changes" (click)="scrollTo($event, 'terms-changes')">Changes</a>
    <a href="#terms-contact" (click)="scrollTo($event, 'terms-contact')">Contact</a>
  </nav>

  <div class="info-grid info-grid--terms">
    <article class="info-card" id="terms-intro">
    <p class="info-updated">Last updated: September 20, 2025</p>
    <p>Welcome to Lootlucky.com. By accessing or using our website, www.lootlucky.com,
      (the "Site"), you agree to be bound by these Terms and Conditions ("Terms"). If you do
      not agree with these Terms, please do not use our Site.</p>
    </article>

    <article class="info-card" id="terms-use">
      <h2 class="info-block-title"><span class="info-icon info-icon--gold">1</span> Use of the Site</h2>
      <p>You agree to use the Site only for lawful purposes and in a manner consistent with all applicable laws and regulations. You are prohibited from:</p>
      <ul>
        <li>Attempting to interfere with the Site's functionality or security.</li>
        <li>Using automated systems (e.g., bots, scripts) to access or scrape the Site.</li>
        <li>Engaging in any activity that disrupts or imposes an unreasonable burden on our infrastructure.</li>
      </ul>
      <p>You must be at least 18 years old or have the consent of a parent or guardian to use this Site.</p>
    </article>

    <article class="info-card" id="terms-accounts">
      <h2 class="info-block-title"><span class="info-icon info-icon--wine">2</span> Accounts</h2>
      <p>To make a purchase, you may need to create an account. You are responsible for:</p>
      <ul>
        <li>Providing accurate, current, and complete information during registration.</li>
        <li>Maintaining the security of your account credentials.</li>
        <li>Notifying us immediately of any unauthorized use of your account.</li>
      </ul>
      <p>We reserve the right to suspend or terminate your account if we suspect fraudulent or unauthorized activity.</p>
    </article>

    <article class="info-card" id="terms-payments">
      <h2 class="info-block-title"><span class="info-icon info-icon--teal">3</span> Purchases and Payments</h2>
      <p>All prices listed on the Site are in [currency, e.g., USD] and exclude applicable taxes and shipping costs unless otherwise stated. We reserve the right to change prices at any time without notice, but this will not affect orders already placed.</p>
      <p>Payments are processed through secure third-party payment processors. You agree to provide accurate payment information and authorize us to charge the listed price for your order.</p>
    </article>

    <article class="info-card" id="terms-shipping">
      <h2 class="info-block-title"><span class="info-icon info-icon--purple">4</span> Shipping and Delivery</h2>
      <p>Our providers aim to ship orders within 10 days of purchase, subject to product availability. Shipping times may vary depending on your location and chosen shipping method. We are not responsible for delays caused by third-party carriers or unforeseen circumstances (e.g., weather, customs delays).</p>
      <p>You are responsible for providing accurate shipping information. We are not liable for delivery failures due to incorrect or incomplete addresses.</p>
    </article>

    <article class="info-card" id="terms-returns">
      <h2 class="info-block-title"><span class="info-icon info-icon--coral">5</span> Returns and Refunds</h2>
      <p>We do not accept returns because you are paying for a product review only. If you are a lucky winner of a free item, and it arrives damaged, the vendor will work with you in 48 hours to resolve your concern, but may take up to 30 days for a final decision.</p>
    </article>

    <article class="info-card" id="terms-products">
      <h2 class="info-block-title"><span class="info-icon info-icon--olive">6</span> Product Descriptions and Availability</h2>
      <p>We strive to ensure that product descriptions, images, and prices on the Site are accurate. However, we do not guarantee that all information is error-free. If a product is not as described, your sole remedy is to return it in accordance with our return policy.</p>
      <p>Products are subject to availability. We reserve the right to limit quantities or discontinue products without notice.</p>
    </article>

    <article class="info-card" id="terms-ip">
      <h2 class="info-block-title"><span class="info-icon info-icon--gold">7</span> Intellectual Property</h2>
      <p>All content on the Site, including text, images, logos, and designs, is owned by or licensed to us and is protected by copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, or use any content without our prior written consent.</p>
    </article>

    <article class="info-card" id="terms-liability">
      <h2 class="info-block-title"><span class="info-icon info-icon--wine">8</span> Limitation of Liability</h2>
      <p>To the fullest extent permitted by law, Lootlucky.com nor the parent company World of Webinars, Llc shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Site or purchase of products, including but not limited to loss of profits, data, or use.</p>
      <p>Our total liability for any claim related to your purchase shall not exceed the amount paid for the product(s) review in question.</p>
    </article>

    <article class="info-card" id="terms-law">
      <h2 class="info-block-title"><span class="info-icon info-icon--teal">9</span> Governing Law</h2>
      <p>These Terms are governed by the laws of Texas, USA. Any disputes arising from these Terms or your use of the Site will be resolved in the courts of Texas, USA.</p>
    </article>

    <article class="info-card" id="terms-changes">
      <h2 class="info-block-title"><span class="info-icon info-icon--purple">10</span> Changes to These Terms</h2>
      <p>We may update these Terms from time to time. The updated Terms will be posted on the Site with the "Last Updated" date. Your continued use of the Site after such changes constitutes your acceptance of the revised Terms.</p>
    </article>

    <article class="info-card" id="terms-contact">
      <h2 class="info-block-title"><span class="info-icon info-icon--coral">11</span> Contact Us</h2>
      <p>If you have any questions about these Terms, please contact us at:</p>
      <p><a routerLink="/Contact">www.lootlucky.com/Contact</a></p>
      <p>By using our Site, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.</p>
      <a class="info-cta" routerLink="/Contact">Ask a question</a>
    </article>
  </div>
</div>
